import { useReadOnly } from "@/state/store";

/**
 * Fixed-position banner shown at the top of every screen for a reviewer
 * (Magic-Link) session. Makes it unambiguous that the user is in read-only
 * mode — paired with greyed-out mutation buttons (`useReadOnly()`).
 *
 * Mounted once in the App shell so it survives route transitions.
 */
export function ReadOnlyBanner() {
  const readOnly = useReadOnly();
  if (!readOnly) return null;
  return (
    <div className="readonly-banner" role="status" aria-live="polite">
      <span aria-hidden="true">🔒</span>
      <span>
        Read-only-Session · Reviewer-Modus · Mutationen deaktiviert
      </span>
    </div>
  );
}
